export const deviceList = [
    { "serial_number": "i386", "model_number": "iPhone Simulator" },
    { "serial_number": "x86_64", "model_number": "iPhone Simulator" },
    { "serial_number": "arm64", "model_number": "iPhone Simulator" },
    { "serial_number": "iPhone1,1", "model_number": "iPhone" },
    { "serial_number": "iPhone1,2", "model_number": "iPhone 3G" },
    { "serial_number": "iPhone2,1", "model_number": "iPhone 3GS" },
    { "serial_number": "iPhone3,1", "model_number": "iPhone 4" },
    { "serial_number": "iPhone3,2", "model_number": "iPhone 4 GSM Rev A" },
    { "serial_number": "iPhone3,3", "model_number": "iPhone 4 CDMA" },
    { "serial_number": "iPhone4,1", "model_number": "iPhone 4S" },
    { "serial_number": "iPhone5,1", "model_number": "iPhone 5 (GSM)" },
    { "serial_number": "iPhone5,2", "model_number": "iPhone 5 (GSM+CDMA)" },
    { "serial_number": "iPhone5,3", "model_number": "iPhone 5C (GSM)" },
    { "serial_number": "iPhone5,4", "model_number": "iPhone 5C (Global)" },
    { "serial_number": "iPhone6,1", "model_number": "iPhone 5S (GSM)" },
    { "serial_number": "iPhone6,2", "model_number": "iPhone 5S (Global)" },
    { "serial_number": "iPhone7,1", "model_number": "iPhone 6 Plus" },
    { "serial_number": "iPhone7,2", "model_number": "iPhone 6" },
    { "serial_number": "iPhone8,1", "model_number": "iPhone 6s" },
    { "serial_number": "iPhone8,2", "model_number": "iPhone 6s Plus" },
    { "serial_number": "iPhone8,4", "model_number": "iPhone SE (GSM)" },
    { "serial_number": "iPhone9,1", "model_number": "iPhone 7" },
    { "serial_number": "iPhone9,2", "model_number": "iPhone 7 Plus" },
    { "serial_number": "iPhone9,3", "model_number": "iPhone 7" },
    { "serial_number": "iPhone9,4", "model_number": "iPhone 7 Plus" },
    { "serial_number": "iPhone10,1", "model_number": "iPhone 8" },
    { "serial_number": "iPhone10,2", "model_number": "iPhone 8 Plus" },
    { "serial_number": "iPhone10,3", "model_number": "iPhone X Global" },
    { "serial_number": "iPhone10,4", "model_number": "iPhone 8" },
    { "serial_number": "iPhone10,5", "model_number": "iPhone 8 Plus" },
    { "serial_number": "iPhone10,6", "model_number": "iPhone X GSM" },
    { "serial_number": "iPhone11,2", "model_number": "iPhone XS" },
    { "serial_number": "iPhone11,4", "model_number": "iPhone XS Max" },
    { "serial_number": "iPhone11,6", "model_number": "iPhone XS Max Global" },
    { "serial_number": "iPhone11,8", "model_number": "iPhone XR" },
    { "serial_number": "iPhone12,1", "model_number": "iPhone 11" },
    { "serial_number": "iPhone12,3", "model_number": "iPhone 11 Pro" },
    { "serial_number": "iPhone12,5", "model_number": "iPhone 11 Pro Max" },
    { "serial_number": "iPhone12,8", "model_number": "iPhone SE 2nd Gen" },
    { "serial_number": "iPhone13,1", "model_number": "iPhone 12 Mini" },
    { "serial_number": "iPhone13,2", "model_number": "iPhone 12" },
    { "serial_number": "iPhone13,3", "model_number": "iPhone 12 Pro" },
    { "serial_number": "iPhone13,4", "model_number": "iPhone 12 Pro Max" },
    { "serial_number": "iPhone14,2", "model_number": "iPhone 13 Pro" },
    { "serial_number": "iPhone14,3", "model_number": "iPhone 13 Pro Max" },
    { "serial_number": "iPhone14,4", "model_number": "iPhone 13 Mini" },
    { "serial_number": "iPhone14,5", "model_number": "iPhone 13" },
    { "serial_number": "iPhone14,6", "model_number": "iPhone SE 3rd Gen" },
    { "serial_number": "iPhone14,7", "model_number": "iPhone 14" },
    { "serial_number": "iPhone14,8", "model_number": "iPhone 14 Plus" },
    { "serial_number": "iPhone15,2", "model_number": "iPhone 14 Pro" },
    { "serial_number": "iPhone15,3", "model_number": "iPhone 14 Pro Max" },
    { "serial_number": "iPhone15,4", "model_number": "iPhone 15" },
    { "serial_number": "iPhone15,5", "model_number": "iPhone 15 Plus" },
    { "serial_number": "iPhone16,1", "model_number": "iPhone 15 Pro" },
    { "serial_number": "iPhone16,2", "model_number": "iPhone 15 Pro Max" },
    { "serial_number": "iPhone17,1", "model_number": "iPhone 16 Pro" },
    { "serial_number": "iPhone17,2", "model_number": "iPhone 16 Pro Max" },
    { "serial_number": "iPhone17,3", "model_number": "iPhone 16" },
    { "serial_number": "iPhone17,4", "model_number": "iPhone 16 Plus" },
    { "serial_number": "iPod1,1", "model_number": "1st Gen iPod" },
    { "serial_number": "iPod2,1", "model_number": "2nd Gen iPod" },
    { "serial_number": "iPod3,1", "model_number": "3rd Gen iPod" },
    { "serial_number": "iPod4,1", "model_number": "4th Gen iPod" },
    { "serial_number": "iPod5,1", "model_number": "5th Gen iPod" },
    { "serial_number": "iPod7,1", "model_number": "6th Gen iPod" },
    { "serial_number": "iPod9,1", "model_number": "7th Gen iPod" },
    { "serial_number": "iPad1,1", "model_number": "iPad" },
    { "serial_number": "iPad1,2", "model_number": "iPad 3G" },
    { "serial_number": "iPad2,1", "model_number": "2nd Gen iPad" },
    { "serial_number": "iPad2,2", "model_number": "2nd Gen iPad GSM" },
    { "serial_number": "iPad2,3", "model_number": "2nd Gen iPad CDMA" },
    { "serial_number": "iPad2,4", "model_number": "2nd Gen iPad New Revision" },
    { "serial_number": "iPad3,1", "model_number": "3rd Gen iPad" },
    { "serial_number": "iPad3,2", "model_number": "3rd Gen iPad CDMA" },
    { "serial_number": "iPad3,3", "model_number": "3rd Gen iPad GSM" },
    { "serial_number": "iPad2,5", "model_number": "iPad mini" },
    { "serial_number": "iPad2,6", "model_number": "iPad mini GSM+LTE" },
    { "serial_number": "iPad2,7", "model_number": "iPad mini CDMA+LTE" }
]
